module.exports = __webpack_public_path__ + "static/media/doc.0afea58d.svg";